/** @format */

import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Home_en from '../views/Home_en.vue';
import Home_jp from '../views/Home_jp.vue';
import Home_cn from '../views/Home_cn.vue';
import PageNotFound from '../views/PageNotFound.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        props: { redirect: '/changduk' },
    },
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () =>
    //         import(/* webpackChunkName: "about" */ '../views/About.vue'),
    // },
    { path: '/pageNotFound', component: PageNotFound },
    {
        path: '/en/:intro_name',
        name: 'Intro_en',
        component: Home_en,
    },
    {
        path: '/jp/:intro_name',
        name: 'Intro_jp',
        component: Home_jp,
    },
    {
        path: '/cn/:intro_name',
        name: 'Intro_cn',
        component: Home_cn,
    },
    {
        path: '/:intro_name',
        name: 'Intro',
        component: Home,
    },
    { path: '*', component: PageNotFound },
];

const router = new VueRouter({
    routes,
});

router.beforeEach((to, from, next) => {
    if (
        (from.name && to.name == 'Home') ||
        (from.name == to.name && to.path != from.path)
    ) {
        location.reload();
    }
    next();
});
export default router;
